/* LB 25-10-2026: carrito lateral propio (sustituye a UpCart). v2: «Completa tu look» de uno en uno (flechas, puntos, pasa solo).
   - Abre al añadir a la cesta (formularios del tema, selector de packs, look completo) y al tocar el icono de la cesta.
   - Cambia cantidades / quita / añade "Completa tu look" con la Ajax API de Shopify y repinta con ?sections=lb-carrito.
   - Captura los clics y envíos ANTES que el JS antiguo del tema (listeners en window, fase de captura), para que solo haya un carrito. */
(function () {
  'use strict';
  if (window.lbCarrito) return;
  var SECTION = 'lb-carrito';
  var root = document.getElementById('lbc');
  if (!root) return;
  var panel = root.querySelector('.lbc__panel');
  var lastFocus = null;
  var busy = false;
  var lockY = 0;
  var ownFetch = false;
  var lastPaint = 0, hookP = null, loadT = null;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function isOpen() { return root.classList.contains('is-open'); }

  function lock(on) {
    var b = document.body, h = document.documentElement;
    if (on) {
      lockY = window.scrollY || h.scrollTop || 0;
      h.classList.add('lbc-lock');
      b.style.position = 'fixed'; b.style.top = -lockY + 'px'; b.style.left = '0'; b.style.right = '0'; b.style.width = '100%';
    } else {
      h.classList.remove('lbc-lock');
      b.style.position = ''; b.style.top = ''; b.style.left = ''; b.style.right = ''; b.style.width = '';
      window.scrollTo(0, lockY);
    }
  }

  function open() {
    if (isOpen()) return;
    lastFocus = document.activeElement;
    /* En la vista previa de Shopify su barra negra tapa el final del carrito: se deja hueco solo en ese caso */
    document.documentElement.classList.toggle('lbc-pv', !!document.getElementById('PBarNextFrameWrapper') || !!document.getElementById('preview-bar-iframe'));
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    lock(true);
    carInit(); carStart(); tmTick();
    window.setTimeout(function () { try { panel.focus({ preventScroll: true }); } catch (e) { panel.focus(); } }, 30);
  }
  function close() {
    if (!isOpen()) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    lock(false);
    clearInterval(carT);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  /* 27-10: el carrito se abre AL INSTANTE al pulsar «Añadir» con una barra de carga; el contenido llega después (como UpCart) */
  function loading(on) {
    clearTimeout(loadT);
    root.classList.toggle('is-loading', !!on);
    if (on) loadT = setTimeout(function () { root.classList.remove('is-loading'); }, 8000);
  }

  /* 28-10 (Ayoub): «se abre pero se queda cargando». Shopify tarda ~1 s en confirmar cualquier añadido (es su servidor, igual con UpCart),
     así que la línea se pinta YA con los datos que tenemos (provisional) y luego se cambia por la buena con descuentos y totales. */
  var pcache = {};
  function money(c) { return (Math.round(c) / 100).toFixed(2).replace('.', ',') + '\u00A0€'; } /* 30-10: formato «59,95 €» */
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function cacheProduct(pr) {
    if (!pr || !pr.variants) return;
    var names = (pr.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
    pr.variants.forEach(function (v) {
      var vt = [];
      [v.option1, v.option2, v.option3].forEach(function (o, k) { if (o && names[k] && !(names[k] === 'Title' && o === 'Default Title')) vt.push(names[k] + ': ' + o); });
      var img = (v.featured_image && v.featured_image.src) || pr.featured_image || '';
      if (img && img.indexOf('//') === 0) img = 'https:' + img;
      pcache[v.id] = { t: pr.title, v: vt.join(', '), p: v.price, c: v.compare_at_price || 0, img: img };
    });
    /* precarga de las fotos para que la línea provisional salga ya con foto */
    var seen = {};
    Object.keys(pcache).forEach(function (k) { var u = pcache[k].img; if (u && !seen[u] && Object.keys(seen).length < 12) { seen[u] = 1; var im = new Image(); im.src = u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=300'; } });
  }
  function warmProduct() {
    var m = window.location.pathname.match(/\/products\/([^\/?#.]+)/);
    if (!m) return;
    var h = m[m.length - 1];
    var go = function () { ownFetch = true; var p = fetch('/products/' + h + '.js', { credentials: 'same-origin' }); ownFetch = false; p.then(function (r) { return r.json(); }).then(cacheProduct).catch(function () {}); };
    if (window.requestIdleCallback) window.requestIdleCallback(go, { timeout: 2500 }); else setTimeout(go, 1200);
  }
  /* Si aún no ha llegado la ficha (clic muy rápido), se usan los datos que Shopify ya deja en la página */
  function pageVariant(id) {
    try {
      var pr = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product; if (!pr || !pr.variants) return null;
      for (var i = 0; i < pr.variants.length; i++) {
        var v = pr.variants[i]; if (Number(v.id) !== Number(id)) continue;
        var og = document.querySelector('meta[property="og:image:secure_url"], meta[property="og:image"]');
        var nm = String(v.name || '').split(' - ')[0];
        return { t: nm, v: v.public_title ? String(v.public_title).replace(/ \/ /g, ', ') : '', p: v.price || 0, c: 0, img: og ? og.content.replace(/^http:/, 'https:') : '' };
      }
    } catch (e) {}
    return null;
  }
  function optimistic(items) {
    var inner = document.getElementById('lbc-inner');
    if (!inner || !items || !items.length) return;
    var list = inner.querySelector('.lbc__items');
    if (!list) {
      var sc = inner.querySelector('[data-lbc-scroll]'); if (!sc) return;
      var em = sc.querySelector('.lbc__empty'); if (em) em.remove();
      list = document.createElement('ul'); list.className = 'lbc__items'; list.setAttribute('role', 'list'); sc.insertBefore(list, sc.firstChild);
      /* LB 28-10 coach (P23): botón provisional también «Continuar» (texto fijo, sin precio).
         28-10 (Ayoub, en vivo): con la cesta vacía salía solo la lista y luego «cambiaba todo». Ahora se pinta ya la cesta entera
         (cuenta atrás, hueco de la barra de descuento, «Completa tu look» cargando y botón de pago) y al confirmar solo se rellenan los datos */
      var tier = document.createElement('div'); tier.className = 'lbc__tier lbc__tier--temp';
      tier.innerHTML = '<p class="lbc__tier-t">Calculando tu descuento…</p><div class="lbc__tier-bar" aria-hidden="true"><span class="lbc__seg"></span><span class="lbc__seg"></span></div>';
      sc.insertBefore(tier, list);
      var bar = inner.querySelector('.lbc__bar'); if (bar) bar.innerHTML = 'Envío gratis · Cesta reservada <b class="lbc__timer">10:00</b>';
      if (!inner.querySelector('.lbc__foot')) {
        var ft = document.createElement('footer'); ft.className = 'lbc__foot lbc__foot--temp';
        var arrs = '<button type="button" class="lbc__arr" disabled tabindex="-1" aria-hidden="true"></button><button type="button" class="lbc__arr" disabled tabindex="-1" aria-hidden="true"></button>';
        ft.innerHTML = '<section class="lbc__ups"><div class="lbc__ups-h"><h3 class="lbc__ups-t">Completa tu look</h3>' + arrs + '</div>' +
          '<div class="lbc__up lbc__up--sk" aria-hidden="true"><span class="lbc__up-img"></span><div class="lbc__up-info"><i></i><i></i><i></i></div></div></section>' +
          '<p class="lbc__sum lbc__sum--total"><span>Total</span><strong data-lbc-total>…</strong></p><p class="lbc__ship"><svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M3.5 7.5H14.5V17H3.5V7.5Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M14.5 10.5H18.3L20.5 13.5V17H14.5V10.5Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><circle cx="7" cy="17.8" r="1.7" stroke="currentColor" stroke-width="1.6"/><circle cx="17.5" cy="17.8" r="1.7" stroke="currentColor" stroke-width="1.6"/></svg>Envío gratis en toda España</p><div class="lbc__checkout-form"><button type="button" class="lbc__checkout" disabled data-lbc-temp-total>Continuar</button></div><div class="lbc__secure lbc__secure--sk"></div>';
        var mg = inner.querySelector('.lbc__msg'); inner.insertBefore(ft, mg || null);
      }
    }
    var added = 0, addCents = 0;
    items.forEach(function (it) {
      var id = Number(it.id), q = Number(it.quantity) || 1; if (!id) return;
      added += q;
      var same = list.querySelector('.lbc__item[data-key^="' + id + ':"], .lbc__item[data-vid="' + id + '"]');
      if (same) { var sp = same.querySelector('.lbc__qty span'); if (sp) sp.textContent = (parseInt(sp.textContent, 10) || 0) + q; return; }
      var d = pcache[id] || it._d || pageVariant(id); if (!d) return;
      addCents += d.p * q;
      var li = document.createElement('li');
      li.className = 'lbc__item is-temp'; li.setAttribute('data-vid', id);
      li.innerHTML = '<span class="lbc__img">' + (d.img ? '<img src="' + esc(d.img) + (d.img.indexOf('?') > -1 ? '&' : '?') + 'width=300" alt="">' : '') + '</span>' +
        '<div class="lbc__info"><div class="lbc__top"><span class="lbc__name">' + esc(d.t) + '</span><span class="lbc__rm" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M4 6.5h16M9.5 6.5V4.8c0-.7.6-1.3 1.3-1.3h2.4c.7 0 1.3.6 1.3 1.3v1.7M6.5 6.5l.8 12.2c.1 1 .9 1.8 1.9 1.8h5.6c1 0 1.8-.8 1.9-1.8l.8-12.2M10 10.5v6M14 10.5v6" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span></div>' +
        (d.v ? '<p class="lbc__var">' + esc(d.v) + '</p>' : '') +
        '<p class="lbc__price">' + (d.c > d.p ? '<s>' + money(d.c * q) + '</s>' : '') + '<strong>' + money(d.p * q) + '</strong></p>' +
        '<div class="lbc__row"><div class="lbc__qty"><button type="button" disabled>−</button><span>' + q + '</span><button type="button" disabled>+</button></div></div></div>';
      list.insertBefore(li, list.firstChild);
    });
    if (added) {
      var n = (parseInt(inner.getAttribute('data-count'), 10) || 0) + added;
      inner.setAttribute('data-count', n);
      var t = inner.querySelector('#lbc-title'); if (t) t.textContent = 'Tu cesta • ' + n;
      var sc2 = inner.querySelector('[data-lbc-scroll]'); if (sc2) sc2.scrollTop = 0;
    }
  }

  function failMsg(t) { msg(t); refresh(); }
  function msg(text) {
    var m = $('[data-lbc-msg]', root);
    if (!m) return;
    m.textContent = text; m.hidden = false;
    clearTimeout(msg.t); msg.t = setTimeout(function () { var x = $('[data-lbc-msg]', root); if (x) x.hidden = true; }, 4500);
  }

  function updateBubble(html) {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble || !html) return;
    var tmp = document.createElement('div'); tmp.innerHTML = html;
    var inner = tmp.querySelector('.shopify-section') || tmp;
    bubble.innerHTML = inner.innerHTML;
  }

  function paint(sections) {
    loading(false);
    if (!sections) return;
    lastPaint = Date.now();
    var html = sections[SECTION];
    if (html) {
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var fresh = tmp.querySelector('#lbc-inner');
      var cur = document.getElementById('lbc-inner');
      if (fresh && cur) {
        var sc = cur.querySelector('[data-lbc-scroll]'), top = sc ? sc.scrollTop : 0;
        var rail = cur.querySelector('[data-lbc-rail]'), left = rail ? rail.scrollLeft : 0;
        /* el aviso que se esté viendo sigue visible tras repintar */
        var om = cur.querySelector('[data-lbc-msg]'), nm = fresh.querySelector('[data-lbc-msg]');
        if (om && nm && !om.hidden) { nm.textContent = om.textContent; nm.hidden = false; }
        cur.replaceWith(fresh);
        var sc2 = fresh.querySelector('[data-lbc-scroll]'); if (sc2) sc2.scrollTop = top;
        var rail2 = fresh.querySelector('[data-lbc-rail]'); if (rail2) rail2.scrollLeft = left;
      }
    }
    if (sections['cart-icon-bubble']) updateBubble(sections['cart-icon-bubble']);
    carInit(); tmTick(); protSync();
  }

  /* 31-10 r10: «Envío protegido» (producto envio-protegido, 3,95 €). Preparado sin activar: si el producto no está activo,
     la casilla sale oculta y desactivada y aquí no pasa nada.
     - La casilla puede estar en la cesta lateral o en /cart (main-cart-footer). En /cart se recarga la página tras el cambio.
     - La burbuja del icono enseña solo las prendas (sin el envío protegido).
     - Si en la cesta ya solo queda el envío protegido, se quita solo; si alguien lo añade más de una vez, se deja en 1. */
  function onCartPage() { return /^\/cart\/?$/.test(window.location.pathname); }
  function protPost(url, body) {
    body.sections = SECTION + ',cart-icon-bubble'; body.sections_url = window.location.pathname;
    return post(url, body).then(function (d) { if (onCartPage()) { window.location.reload(); return d; } paint(d.sections); return d; });
  }
  function protSync() {
    var inner = document.getElementById('lbc-inner'); if (!inner) return;
    var n = parseInt(inner.getAttribute('data-count'), 10) || 0, pq = parseInt(inner.getAttribute('data-prot-q'), 10) || 0;
    if (!pq) return;
    var b = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    if (b) {
      if (n === 0) b.remove();
      else {
        var s1 = b.querySelector('span[aria-hidden]'); if (s1) s1.textContent = n;
        var s2 = b.querySelector('.visually-hidden'); if (s2) s2.textContent = s2.textContent.replace(/\d+/, n);
      }
    }
    var vid = inner.getAttribute('data-prot-vid');
    if (protSync.busy || !vid) return;
    var want = n === 0 ? 0 : (pq > 1 ? 1 : -1);
    if (want < 0) return;
    protSync.busy = true;
    protPost('/cart/change.js', { id: String(vid), quantity: want }).catch(function () {}).then(function () { protSync.busy = false; });
  }
  function protToggle(inp) {
    var id = inp.getAttribute('data-lbc-prot');
    if (!id || busy) { inp.checked = !inp.checked; return; }
    var lab = inp.closest('label'), on = inp.checked;
    busy = true; if (lab) lab.classList.add('is-busy'); loading(true);
    var p = on ? protPost('/cart/add.js', { items: [{ id: Number(id), quantity: 1 }] }) : protPost('/cart/change.js', { id: String(id), quantity: 0 });
    p.catch(function () { inp.checked = !on; loading(false); if (lab) lab.classList.remove('is-busy'); msg('No se ha podido cambiar el envío protegido. Inténtalo de nuevo.'); })
      .then(function () { busy = false; });
  }
  document.addEventListener('change', function (ev) {
    var inp = ev.target && ev.target.closest && ev.target.closest('input[data-lbc-prot]');
    if (inp) protToggle(inp);
  });


  /* Cuenta atrás «Cesta reservada» (como UpCart): 10 minutos desde que entra el primer producto.
     Se guarda la hora de inicio, así no vuelve a empezar al recargar. Si la cesta se vacía, se borra. Al llegar a 0 no se quita nada. */
  var TM_KEY = 'lbc_t0', TM_MS = 10 * 60 * 1000, tmI = null;
  function tmGet() { try { return parseInt(window.localStorage.getItem(TM_KEY), 10) || 0; } catch (e) { return 0; } }
  function tmSet(v) { try { if (v) window.localStorage.setItem(TM_KEY, String(v)); else window.localStorage.removeItem(TM_KEY); } catch (e) {} }
  function tmTick() {
    var inner = document.getElementById('lbc-inner');
    var n = inner ? parseInt(inner.getAttribute('data-count'), 10) || 0 : 0;
    if (!n) { tmSet(0); window.clearInterval(tmI); tmI = null; return; }
    var t0 = tmGet(); if (!t0) { t0 = Date.now(); tmSet(t0); }
    var paint = function () {
      var el = root.querySelector('#lbc-inner [data-lbc-timer]');
      if (!el) return;
      var left = Math.max(0, t0 + TM_MS - Date.now());
      if (left <= 0) {
        var bar = root.querySelector('#lbc-inner [data-lbc-timer-bar]');
        if (bar) bar.innerHTML = 'Envío gratis · 30 días para devolver';
        window.clearInterval(tmI); tmI = null; return;
      }
      var s = Math.ceil(left / 1000), m = Math.floor(s / 60); s = s % 60;
      el.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
    };
    paint();
    if (!tmI) tmI = window.setInterval(paint, 1000);
  }

  /* 25-10 coach: sin botones de pago rápido en el carrito (quitado el código que los gestionaba el 27-10) */

  /* "Completa tu look": un producto cada vez, con flechas, puntos y paso automático cada 5 s (se para si el cliente lo toca) */
  var carT = null, carHold = 0;
  function carParts() {
    var rail = root.querySelector('[data-lbc-rail]');
    if (!rail) return null;
    var n = 0; Array.prototype.forEach.call(rail.children, function (k) { if (!k.hasAttribute('data-lbc-clone')) n++; });
    return { rail: rail, n: n, dots: root.querySelector('[data-lbc-dots]') };
  }
  function carIdx(c) { return Math.round(c.rail.scrollLeft / Math.max(1, c.rail.clientWidth)) % Math.max(1, c.n); }
  /* LB 28-10 v30 22:00 (Ayoub): en bucle, como las fotos. Del último pasa al primero SIGUIENDO hacia delante (…, último, 1, 2, …)
     con una copia del primero al final: se desliza hasta la copia y luego salta sin animación al primero real. Antes volvía hacia atrás pasando rápido por todos. */
  function carClone(c) {
    var last = c.rail.lastElementChild;
    if (last && last.hasAttribute('data-lbc-clone')) return;
    var first = c.rail.firstElementChild; if (!first) return;
    var k = first.cloneNode(true);
    k.setAttribute('data-lbc-clone', ''); k.setAttribute('aria-hidden', 'true'); k.setAttribute('inert', '');
    Array.prototype.forEach.call(k.querySelectorAll('[id]'), function (e) { e.removeAttribute('id'); });
    c.rail.appendChild(k);
  }
  /* salto sin animación: el carril tiene scroll-behavior:smooth y scroll-snap en el CSS, así que se quitan un momento (si no, el «salto» volvía a ser la marcha atrás rápida) */
  function carJump(rail, left) {
    var sb = rail.style.scrollBehavior, sn = rail.style.scrollSnapType;
    rail.style.scrollBehavior = 'auto'; rail.style.scrollSnapType = 'none';
    rail.scrollLeft = left; void rail.offsetWidth;
    window.requestAnimationFrame(function () { rail.style.scrollBehavior = sb; rail.style.scrollSnapType = sn; });
  }
  function carGo(i, smooth) {
    var c = carParts(); if (!c || !c.n) return;
    var w = Math.max(1, c.rail.clientWidth), cur = Math.round(c.rail.scrollLeft / w), rail = c.rail;
    if (c.n > 1 && smooth !== false && i >= c.n && cur >= c.n - 1) {
      carClone(c);
      rail.scrollTo({ left: c.n * w, behavior: 'smooth' });
      clearTimeout(rail.__lp); rail.__lp = setTimeout(function () { carJump(rail, 0); carSync(); }, 700);
      return;
    }
    if (c.n > 1 && smooth !== false && i < 0 && cur === 0) {
      carClone(c);
      carJump(rail, c.n * w);
      window.requestAnimationFrame(function () { rail.scrollTo({ left: (c.n - 1) * w, behavior: 'smooth' }); });
      return;
    }
    i = (i + c.n) % c.n;
    rail.scrollTo({ left: i * w, behavior: smooth === false ? 'auto' : 'smooth' });
  }
  function carSync() {
    var c = carParts(); if (!c) return;
    var i = carIdx(c);
    if (c.dots) {
      if (c.dots.children.length !== c.n) { c.dots.innerHTML = c.n > 1 ? new Array(c.n + 1).join('<span></span>') : ''; }
      Array.prototype.forEach.call(c.dots.children, function (d, k) { d.classList.toggle('is-on', k === i); });
    }
    root.querySelectorAll('[data-lbc-arr]').forEach(function (b) { b.hidden = c.n < 2; });
  }
  function carStart() {
    clearInterval(carT);
    carT = setInterval(function () {
      if (!isOpen() || Date.now() < carHold) return;
      var c = carParts(); if (!c || c.n < 2) return;
      var a = document.activeElement; if (a && a.closest && a.closest('[data-lbc-up]')) return;
      carGo(carIdx(c) + 1);
    }, 5000);
  }
  function carInit() {
    var c = carParts(); if (!c) return;
    if (!c.rail.__lbc) {
      c.rail.__lbc = 1;
      c.rail.addEventListener('scroll', function () { clearTimeout(c.rail.__t); c.rail.__t = setTimeout(carSync, 80); }, { passive: true });
      ['touchstart', 'pointerdown', 'focusin'].forEach(function (e) { c.rail.addEventListener(e, function () { carHold = Date.now() + 12000; }, { passive: true }); });
    }
    carSync();
  }

  var refP = null;
  function refresh() {
    if (refP) return refP;
    ownFetch = true;
    var p = fetch('/?sections=' + SECTION + ',cart-icon-bubble', { credentials: 'same-origin' });
    ownFetch = false;
    refP = p
      .then(function (r) { return r.json(); })
      .then(paint)
      .catch(function () { loading(false); })
      .then(function () { refP = null; });
    return refP;
  }

  function post(url, body) {
    ownFetch = true;
    var p = fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    });
    ownFetch = false;
    return p.then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok || d.status) { var e = new Error(d.description || d.message || 'error'); e.data = d; throw e; }
        return d;
      });
    });
  }

  function addItems(items, opts) {
    opts = opts || {};
    return post('/cart/add.js', {
      items: items, sections: SECTION + ',cart-icon-bubble', sections_url: window.location.pathname
    }).then(function (d) { paint(d.sections); if (opts.open !== false) open(); return d; }, function (e) { loading(false); throw e; });
  }

  function change(line, qty) {
    return post('/cart/change.js', { line: line, quantity: qty, sections: SECTION + ',cart-icon-bubble', sections_url: window.location.pathname })
      .then(function (d) { paint(d.sections); return d; });
  }

  /* 28-10: si Shopify no deja añadir (agotado, etc.), se quitan las líneas provisionales repintando la cesta real y el aviso sale DENTRO de la cesta */
  function errText(e) {
    var t = (e && e.message) || '';
    if (/sold out|agotad|not available|no est/i.test(t)) return 'Lo sentimos, esa talla o color se ha agotado.';
    if (/quantity|cantidad|existencias|stock/i.test(t)) return 'No quedan más unidades de este artículo.';
    return 'No se ha podido actualizar la cesta. Inténtalo de nuevo.';
  }

  /* Clics dentro del carrito */
  root.addEventListener('click', function (ev) {
    var t = ev.target;
    if (t.closest('[data-lbc-close]')) { ev.preventDefault(); close(); return; }
    var arr = t.closest('[data-lbc-arr]');
    if (arr) { ev.preventDefault(); carHold = Date.now() + 12000; var c = carParts(); if (c) carGo(carIdx(c) + parseInt(arr.getAttribute('data-lbc-arr'), 10)); return; }
    var q = t.closest('[data-lbc-qty]');
    if (q) {
      ev.preventDefault();
      if (busy) return;
      var li = q.closest('.lbc__item'); if (!li) return;
      busy = true; li.classList.add('is-busy');
      change(parseInt(li.getAttribute('data-line'), 10), parseInt(q.getAttribute('data-lbc-qty'), 10))
        .catch(function (e) { li.classList.remove('is-busy'); msg(errText(e)); })
        .then(function () { busy = false; });
      return;
    }
    var a = t.closest('[data-lbc-add]');
    if (a) { ev.preventDefault(); addUp(a); }
  });
  /* «Completa tu look»: sin propiedades extra, así la misma talla se suma a la misma línea (cantidad 2) en vez de salir dos veces */
  function addUp(a) {
    if (busy) return;
    var card = a.closest('[data-lbc-up]');
    var sel = card && card.querySelector('[data-lbc-up-sel]');
    var id = a.getAttribute('data-lbc-add') || (sel && sel.value) || a.getAttribute('data-lbc-default');
    if (!id) { if (sel) { sel.classList.add('is-err'); try { sel.focus(); sel.showPicker && sel.showPicker(); } catch (e) {} } return; }
    busy = true; a.disabled = true; a.textContent = 'Añadiendo…'; loading(true);
    if (!pcache[id] && card) {
      var im = card.querySelector('.lbc__up-img img'), nm = card.querySelector('.lbc__up-name'), pz = card.querySelector('.lbc__up-price strong');
      var opt = sel && sel.selectedOptions && sel.selectedOptions[0];
      var cents = pz ? Math.round(parseFloat(pz.textContent.replace(/[^\d,]/g, '').replace(',', '.')) * 100) || 0 : 0;
      pcache[id] = { t: nm ? nm.textContent.trim() : '', v: opt && opt.value ? opt.textContent.trim() : '', p: cents, c: 0, img: im ? (im.currentSrc || im.src).replace(/[?&]width=\d+/, '') : '' };
    }
    optimistic([{ id: id, quantity: 1 }]);
    addItems([{ id: Number(id), quantity: 1 }], { open: true })
      .catch(function (e) { a.disabled = false; a.textContent = 'Añadir'; failMsg(errText(e)); })
      .then(function () { busy = false; });
  }
  /* Al elegir la talla se añade directamente, sin volver a pulsar «Añadir» */
  root.addEventListener('change', function (ev) {
    var sel = ev.target.closest('[data-lbc-up-sel]');
    if (!sel) return;
    sel.classList.remove('is-err');
    var card = sel.closest('[data-lbc-up]');
    var a = card && card.querySelector('[data-lbc-add]');
    if (sel.value && a) addUp(a);
  });
  root.addEventListener('submit', function (ev) {
    var b = ev.target.querySelector('.lbc__checkout');
    if (b) { b.setAttribute('data-txt', b.textContent); b.classList.add('is-busy'); b.textContent = 'Abriendo pago seguro…'; }
  });
  document.addEventListener('keydown', function (ev) {
    if (!isOpen()) return;
    if (ev.key === 'Escape') { close(); return; }
    if (ev.key === 'Tab') {
      var f = panel.querySelectorAll('a[href],button:not([disabled]),select,input,[tabindex]:not([tabindex="-1"])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (ev.shiftKey && document.activeElement === first) { ev.preventDefault(); last.focus(); }
      else if (!ev.shiftKey && document.activeElement === last) { ev.preventDefault(); first.focus(); }
    }
  });
  /* Al volver atrás desde el pago (página guardada por el navegador): botón como estaba, carrusel al primero y cesta al día */
  window.addEventListener('pageshow', function (ev) {
    if (!ev.persisted) return;
    var b = root.querySelector('.lbc__checkout.is-busy');
    if (b) { b.classList.remove('is-busy'); b.textContent = b.getAttribute('data-txt') || b.textContent; }
    var c = carParts(); if (c) { c.rail.style.scrollBehavior = 'auto'; c.rail.scrollLeft = 0; c.rail.style.scrollBehavior = ''; }
    carHold = Date.now() + 6000; loading(false);
    refresh();
  });

  /* Abrir con el icono de la cesta (antes que el JS antiguo del tema) */
  window.addEventListener('click', function (ev) {
    if (ev.defaultPrevented) return;
    var a = ev.target.closest && ev.target.closest('#cart-icon-bubble, .header__icon--cart, a[href="/cart"], a[href^="/cart?"]');
    if (!a || root.contains(a)) return;
    ev.preventDefault(); ev.stopImmediatePropagation();
    open();
  }, true);

  /* Añadir a la cesta desde cualquier formulario del tema */
  window.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]') || root.contains(form)) return;
    var sub = ev.submitter;
    if (sub && sub.closest && sub.closest('.shopify-payment-button')) return;
    ev.preventDefault(); ev.stopImmediatePropagation();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-busy', 'true');
    loading(true); open();
    try { var fid = form.querySelector('[name="id"]'); if (fid && fid.value) { var fq = form.querySelector('[name="quantity"]'); optimistic([{ id: fid.value, quantity: fq && fq.value ? fq.value : 1 }]); } } catch (e) {}
    var fd = new FormData(form);
    fd.append('sections', SECTION + ',cart-icon-bubble');
    fd.append('sections_url', window.location.pathname);
    ownFetch = true;
    var p = fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd });
    ownFetch = false;
    p.then(function (r) { return r.json().then(function (d) { if (!r.ok || d.status) { var e = new Error(d.description || d.message); throw e; } return d; }); })
      .then(function (d) { paint(d.sections); open(); })
      .catch(function (e) { loading(false); open(); msg(errText(e)); refresh(); })
      .then(function () { if (btn) btn.removeAttribute('aria-busy'); });
  }, true);

  /* Otros scripts (packs, look completo, apps) que añaden por su cuenta: repintar y abrir */
  var pend = null;
  function later(openIt) {
    clearTimeout(pend);
    pend = setTimeout(function () { refresh().then(function () { if (openIt) open(); }); }, 60);
  }
  /* 27-10: si otro script (selector de packs) añade a la cesta, se abre el carrito al momento y se pide el carrito
     nuevo DENTRO de la misma petición (sections), sin una segunda llamada. Antes tardaba ~2 s y se quedaba en «Añadiendo». */
  var _fetch = window.fetch;
  if (_fetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var mine = ownFetch;
      if (mine || !/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) return _fetch.apply(this, arguments);
      var isAdd = /\/cart\/add/.test(url), injected = false;
      if (isAdd && init && init.body) {
        try {
          if (typeof init.body === 'string' && init.body.charAt(0) === '{') {
            var b = JSON.parse(init.body);
            var its = b.items || (b.id ? [{ id: b.id, quantity: b.quantity || 1 }] : []);
            setTimeout(function () { try { optimistic(its); } catch (e) {} }, 0);
            if (!b.sections) { b.sections = SECTION + ',cart-icon-bubble'; b.sections_url = window.location.pathname; init = Object.assign({}, init, { body: JSON.stringify(b) }); injected = true; }
          } else if (window.FormData && init.body instanceof FormData && !init.body.has('sections')) {
            init.body.append('sections', SECTION + ',cart-icon-bubble'); init.body.append('sections_url', window.location.pathname); injected = true;
          }
        } catch (e) { injected = false; }
      }
      if (isAdd) { loading(true); open(); }
      var p = _fetch.call(this, input, init);
      if (injected) {
        hookP = p.then(function (r) {
          return r.clone().json().then(function (d) {
            if (r.ok && !d.status && d.sections) paint(d.sections);
            else { loading(false); if (!r.ok || d.status) failMsg(errText(new Error(d.description || d.message || ''))); else refresh(); }
          });
        }).catch(function () { loading(false); failMsg(errText(null)); }).then(function () { hookP = null; });
      } else {
        p.then(function (r) { if (r && r.ok) later(isAdd); else loading(false); }).catch(function () { loading(false); });
      }
      return p;
    };
  }
  /* El selector de packs llama a esto después de añadir: el carrito ya está abierto y pintándose; el botón vuelve a su texto al momento */
  window.lbOpenTopCart = function () {
    open();
    if (!hookP && Date.now() - lastPaint > 1500) refresh();
    return Promise.resolve();
  };
  window.upcartOpenCart = window.lbOpenTopCart;
  warmProduct();
  protSync();
  window.lbCarrito = { open: open, close: close, refresh: refresh };
})();
